<template>
  <div class="container">
    <headers></headers>
    <right></right>
    <scrollpage></scrollpage>

    <div class="w box_sizing width_box my_wrap">
      <div class="left_position">
        <left></left>
      </div>

      <div class="question_list_wrap box_sizing">

        <div class="question_list_box">
          <div v-if="list == false">
            <div class="no_data">
              <img src="../assets/images/nodata.png" alt="" />
            </div>
            <div class="no_data_text">
              暂无数据
            </div>
          </div>
          <div
            class="question_list box_sizing flex_box flex_align_center flex_justify_between"
            v-for="(item, index) in list"
            :key="index"
          >
            <div
              class="question_list_info box_sizing flex_box flex_align_center"
              @click="jumpDetail(item.id,item.topic_type_id)"
            >
              <div class="question_list_tihao">{{ item.number }}</div>
              <div class="question_list_title">{{ item.name }}</div>
              <div class="question_list_pinlv" v-if="item.high_status == 1">
                高频
              </div>
              <div class="question_list_gengxin" v-if="item.update == 1">
                更新
              </div>
              <div
                class="question_list_jiangjie flex_box flex_align_center"
                v-if="item.topic_lecture_id != 0"
              >
                <img
                  class="question_list_jiangjieimg"
                  src="../assets/images/jiangjie.png"
                  alt=""
                />
                名师讲解
              </div>
            </div>
            <div class="box_sizing flex_box flex_align_center justify_end">
              <div class="question_lian_cishu">
                练过{{ item.topic_exercise_count }}次
              </div>
              <div class="question_lian_riqi" v-if="item.createtime_text">
                {{ item.createtime_text }}
              </div>
              <div class="question_lian_shoucang">
                <img
                  class="question_list_jiangjieimg"
                  @click="collowCilck(index)"
                  v-if="!item.topic_collect || item.topic_collect == 1"
                  src="../assets/images/shoucang1.png"
                  alt=""
                />
                <img
                  class="question_list_jiangjieimg"
                  @click="collowCilck(index)"
                  v-if="item.topic_collect == 2"
                  src="../assets/images/shoucang2.png"
                  alt=""
                />
                <img
                  class="question_list_jiangjieimg"
                  @click="collowCilck(index)"
                  v-if="item.topic_collect == 3"
                  src="../assets/images/shoucang3.png"
                  alt=""
                />
                <img
                  class="question_list_jiangjieimg"
                  @click="collowCilck(index)"
                  v-if="item.topic_collect == 4"
                  src="../assets/images/shoucang4.png"
                  alt=""
                />
                <img
                  class="question_list_jiangjieimg"
                  @click="collowCilck(index)"
                  v-if="item.topic_collect == 5"
                  src="../assets/images/shoucang5.png"
                  alt=""
                />
                <div class="question_list_sc_box" v-if="item.show">
                  <div class="question_list_sc_list box_sizing">
                    <div
                      class="question_list_sc_item box_sizing flex_box flex_align_center flex_justify_center"
                      @click="collectFun(index, item, 1)"
                    >
                      <img
                        class="question_list_jiangjieimg"
                        src="../assets/images/shoucang1.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="question_list_sc_list box_sizing">
                    <div
                      class="question_list_sc_item box_sizing flex_box flex_align_center flex_justify_center"
                      @click="collectFun(index, item, 2)"
                    >
                      <img
                        class="question_list_jiangjieimg"
                        src="../assets/images/shoucang2.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="question_list_sc_list box_sizing">
                    <div
                      class="question_list_sc_item box_sizing flex_box flex_align_center flex_justify_center"
                      @click="collectFun(index, item, 3)"
                    >
                      <img
                        class="question_list_jiangjieimg"
                        src="../assets/images/shoucang3.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="question_list_sc_list box_sizing">
                    <div
                      class="question_list_sc_item box_sizing flex_box flex_align_center flex_justify_center"
                      @click="collectFun(index, item, 4)"
                    >
                      <img
                        class="question_list_jiangjieimg"
                        src="../assets/images/shoucang4.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="question_list_sc_list box_sizing">
                    <div
                      class="question_list_sc_item box_sizing flex_box flex_align_center flex_justify_center"
                      @click="collectFun(index, item, 5)"
                    >
                      <img
                        class="question_list_jiangjieimg"
                        src="../assets/images/shoucang5.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footers></footers>
  </div>
</template>

<script>
import headers from "@/components/headers";
import footers from "@/components/footders";
import left from "@/components/left";
import right from "@/components/right";
import scrollpage from "@/components/scrollpage";
import "@/css/questionList.css";
var _this;
export default {
  components: {
    headers,
    footers,
    left,
    right,
    scrollpage,
  },
  data() {
    return {
      is_sort: false,
      sort_num: 1, // 1为正序,-1位倒序
      title: "",
      id: "",
      list: [],
      jiangjieId: 0,
      typeId: 0,
      scStatus: false,
      jiangjieList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "有讲解",
        },
        {
          id: 2,
          name: "无讲解",
        },
      ],
      lianxiId: 1,
      lianxiList: [
        {
          id: 1,
          name: "可练习",
        },
        {
          id: 2,
          name: "不可练习",
        },
      ],
      pinlvId: 0,
      pinlvList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "高频",
        },
        {
          id: 2,
          name: "新题",
        },
        {
          id: 3,
          name: "旧题",
        },
      ],
      collectId: undefined,
      collectList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "未收藏",
        },
      ],
      count: 0,
      exercise_count: 0,
      allList: [],
      audio: null,
      keyword: ''
    };
  },
  created() {
    _this = this;
    _this.getParams();
    console.log(_this.$route.path)
    // _this.audio.pause()
  },
  methods: {
    // 跳转题目详情
    jumpDetail(id,type_id) {
      _this.id = type_id;
      console.log('id',id);
      if(!localStorage.getItem("token")) {
        this.$message.error("请登录后再进行答题");return
      } else if (_this.id == 20 || _this.id == 21) {
        // 听写句子
        _this.$router.push({
          path: "/questionType14",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 1) {
        // 朗读句子
        _this.$router.push({
          path: "/questionType1",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 6 || _this.id == 23) {
        // 短文写作
        _this.$router.push({
          path: "/questionType6",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 7 || _this.id == 24) {
        // 总结全文
        _this.$router.push({
          path: "/questionType6",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 8) {
        // 阅读单选
        _this.$router.push({
          path: "/questionType4",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 9) {
        // 阅读多选
        _this.$router.push({
          path: "/questionType7",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 17) {
        // 听力单选
        _this.$router.push({
          path: "/questionType8",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 3) {
        // 描述图片
        _this.$router.push({
          path: "/questionType3",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 2) {
        // 描述图片
        _this.$router.push({
          path: "/questionType9",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 4) {
        // 描述图片
        _this.$router.push({
          path: "/questionType9",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 5 || _this.id == 22 || _this.id == 26 || _this.id == 27) {
        // 短回答
        _this.$router.push({
          path: "/questionType9",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 10) {
        // 段落排序
        _this.$router.push({
          path: "/questionType10",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 11) {
        // 阅读拖拽完型填空
        _this.$router.push({
          path: "/questionType11",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 12) {
        // 阅读下拉完型填空
        _this.$router.push({
          path: "/questionType12",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 16) {
        // 摘要选择
        _this.$router.push({
          path: "/questionType8",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 18) {
        // 补全对话
        _this.$router.push({
          path: "/questionType8",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 13 || _this.id == 25) {
        // 录音总结
        _this.$router.push({
          path: "/questionType14",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 15) {
        // 听力填空
        _this.$router.push({
          path: "/questionType15",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 19) {
        // 识别错词
        _this.$router.push({
          path: "/questionType16",
          query: {
            id: id,
            name: _this.title,
          },
        });
      } else if (_this.id == 14) {
        // 听力多选
        _this.$router.push({
          path: "/questionType17",
          query: {
            id: id,
            name: _this.title,
          },
        });
      }
    },

    //选择收藏哪个
    collowCilck(i) {
      let list = _this.list;
      list.forEach((item, index) => {
        if (i == index && !item.show) {
          item.show = true;
        } else {
          item.show = false;
        }
      });

      _this.list = list;
    },

    // 收藏题目
    collectFun(i, obj, type) {
      // console.log(i)
      let list = _this.list;
      let params = {
        topic_id: obj.id,
        type: type,
      };

      if (localStorage.getItem("token")) {
        _this.$axios
          .post("exercise.topic_collect/collect", params)
          .then((res) => {
            console.log(res);
            if (res.code == 1) {
              list.forEach((item, index) => {
                if (i == index) {
                  item.topic_collect = type;
                  item.show = false;
                }
              });
              _this.list = list;
            } else {
              _this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        _this.$message.error("您还没登录，请先登录");
      }
    },

    // 获取练习列表
    getList() {
      var list = [];
      var params = {
        keyword: this.keyword,
        typeId: this.typeId,
        scene: localStorage.getItem('activeName') && localStorage.getItem('activeName') == 'second' ?
          2 : 1,
      };
      _this.$axios
        .post("exercise.topic/search", params)
        .then((res) => {
          console.log(res);
          if (res.code == 1) {

            _this.list = res.data;
          } else {
            _this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 获取传递过来的参数
    getParams() {
      _this.keyword = _this.$route.query.keyword;
      _this.typeId = _this.$route.query.typeId;
      _this.getList();
    },

    // 修改联系状态
    lianxiChange(e) {
      console.log(e);
      let indexLx = e.target.options.selectedIndex;
      _this.lianxiId = _this.lianxiList[indexLx].id;
      console.log(_this.lianxiId, "修改联系状态");
      _this.screenList();
    },

    // 修改频率状态
    pinlvChange(e) {
      console.log(e);
      let indexPl = e.target.options.selectedIndex;
      _this.pinlvId = _this.pinlvList[indexPl].id;
      console.log(_this.pinlvId);
      _this.screenList();
    },
    // 收藏筛选
    screenCollect(index) {
      _this.collectId = index;
      _this.scStatus = false;
      _this.screenList();
    },
    // 手动筛选
    // /**
    //  * @param {number} type [1:可练,2:频率,3:收藏,4,讲解]
    //  * @param {number} value [对应type的转态值]
    //  */
    screenList() {
      let type_obj = {
        exercise_status: _this.lianxiId, //练习状态 1=可练习2=不可练习
        high_status: _this.pinlvId == 1 ? 1 : undefined, //高频开关 0=关1=开
        time_status: _this.pinlvId < 2 ? undefined : _this.pinlvId == 2 ? 1 : 0, //0=旧题1=新题
        topic_collect: _this.collectId, //收藏 之前添加传的
        topic_lecture_id:
          _this.jiangjieId == 0 ? undefined : _this.jiangjieId == 1 ? 1 : 0, //名师讲解id 0=没有讲解
      };
      let all_list = _this.allList;
      let list = [];
      for (const index in all_list) {
        let istrue = true;
        for (const key in type_obj) {
          if (key == "topic_collect" && all_list[index][key] == null)
            all_list[index][key] = 1;
          if (key == "topic_lecture_id" && all_list[index][key] > 0)
            all_list[index][key] = 1;
          if (
            type_obj[key] != undefined &&
            all_list[index][key] != type_obj[key]
          )
            istrue = false;
        }
        if (istrue) list.push(all_list[index]);
      }

      _this.list = list;
    },

    // 切换讲解
    jiangjieChange(e) {
      _this.screenList();
    },
    sortList() {
      const compare = (obj1, obj2) => {
        let val1 = obj1.number;
        let val2 = obj2.number;
        if (val1 < val2) {
          return -1 * _this.sort_num;
        } else if (val1 > val2) {
          return 1 * _this.sort_num;
        } else {
          return 0;
        }
      };
      console.log(_this.sort_num)
      if (_this.sort_num === 1) {
        _this.sort_num = -1;
      } else {
        _this.sort_num = 1;
      }
      _this.list = _this.list.sort(compare);
    },
  },
};
</script>


<style scoped>
.clear_img {
  position: absolute;
  left: 60px;
  top: 5px;
  width: 16px;
  height: 16px;
}
.pointer {
  cursor: pointer;
  user-select: none;
}
.color_black {
  color: black !important;
}

.no_data{
  width: 300px;
  margin: 0 auto;
}

.no_data_text {
  text-align: center;
  font-size: 17px;
  margin-top: -65px;
}
</style>
